import React, { useContext, useState } from "react";
import { makeStyles, Theme } from "@material-ui/core/styles";
import { Grid, Typography, Card } from "@material-ui/core";
import { LangContext } from "../../context/lang";
import { FaHome, FaRegFilePdf, FaRegQuestionCircle } from "react-icons/fa";

const useStyle = makeStyles((theme: Theme) => ({
  root: {
    height: `calc(100% - ${theme.spacing(4)}px)`,
    width: `calc(100% - ${theme.spacing(4)}px)`,
    padding: theme.spacing(2),
  },
  cardstyle: {
    width: "100%",
    backgroundColor: "#faf7f1",
    boxShadow: "1px 1px 5px 0px rgba(191,192,191,1)",
    WebkitBoxShadow: "1px 1px 5px 0px rgba(191,192,191,1)",
    MozBoxShadow: "1px 1px 5px 0px rgba(191,192,191,1)",
    borderRadius: 8,
    height: "10rem",
    cursor: "pointer",
    "&:hover": {
      background: "#faf7f1",
      boxShadow: `0px 0px 20px -1px #a8a8a8`,
      transition: "box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
    },
  },
  center: {
    width: "100%",
    height: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column",
  },
  icon: {
    color: theme.palette.secondary.main,
    marginBottom: theme.spacing(1),
  },
  iconactive: {
    color: theme.palette.primary.main,
    marginBottom: theme.spacing(1),
  },
  title: { maxWidth: "85%" },
}));

const Information = () => {
  const classes = useStyle();
  const [index, setIndex] = useState<Number>(0);
  const { lang } = useContext(LangContext);
  const info = [
    {
      title: lang.data.gotohomepage,
      link: "https://www.mea.or.th/minisite/doingbusinessinbkk",
      icon: <FaHome size={42} className={classes.icon} />,
      iconactive: <FaHome size={42} className={classes.iconactive} />,
    },
    {
      title: lang.data.mealist,
      link:
        "https://upload.i-bitz.co.th/files/2020/08/13/b63b6a61ab4ae1ca8e2d584a.pdf",
      icon: <FaRegFilePdf size={42} className={classes.icon} />,
      iconactive: <FaRegFilePdf size={42} className={classes.iconactive} />,
    },
    {
      title: lang.data.askforusage,
      link: "https://webboardgis.mea.or.th",
      icon: <FaRegQuestionCircle size={42} className={classes.icon} />,
      iconactive: (
        <FaRegQuestionCircle size={42} className={classes.iconactive} />
      ),
    },
  ];

  const openLink = (link: string) => {
    let a = document.createElement("a");
    a.href = link;
    a.target = "_blank";
    a.click();
  };
  return (
    <div className={classes.root}>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Typography>{lang.data.information}</Typography>
        </Grid>

        {info.map((rs: any, id: any) => {
          return (
            <Grid item xs={12} sm={6} md={3} lg={3} key={rs.title}>
              <Card
                className={classes.cardstyle}
                onClick={() => openLink(rs.link)}
                onMouseEnter={() => {
                  setIndex(id + 1);
                }}
                onMouseLeave={() => {
                  setIndex(0);
                }}
              >
                <div className={classes.center}>
                  {Number(id + 1) === index ? rs.iconactive : rs.icon}
                  <Typography className={classes.title}>{rs.title}</Typography>
                </div>
              </Card>
            </Grid>
          );
        })}
      </Grid>
    </div>
  );
};

export default Information;
